import React from 'react'
import { priceunit } from '../../Components/client-config'
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { deleteDonationFromCart } from '../../Redux/actions/cart';
import { useTranslation } from 'react-i18next';
import { calcTotalGstTax } from '../../utils/helpers';
import { couponDiscountCal, calculateSubTotal, calculateTotalItemDiscount } from '../../utils/menu.utils';
import { DiscountDisplay } from '../../Components/DiscountDisplay';
import { COUPON_TYPES } from '../../lib/constants';
import { ICartItem, ICouponDetails } from '../../lib/types';
import { formatPrice } from '../../utils/format-price';


export default function OrderDetail(props: any) {
    const cartData = useSelector((state: any) => state.cart.cartData);
    const cartQty = useSelector((state: any) => state.cart.cartQty);
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const paymentMethod = useSelector((state: any) => state.payment.paymentMethod);
    const taxDataCash = useSelector((state: any) => state.store.taxDataCash);
    const taxDataCard = useSelector((state: any) => state.store.taxDataCard);
    const donationItems = useSelector((state: any) => state.cart.donationItems);
    const donationData = useSelector((state: any) => state.cart.donationData);
    const isReverseCard = useSelector((state: any) => state.payment.payment_tax);
    const dispatch:any = useDispatch();
    const { t } = useTranslation();
    const payment_tax = useSelector((state: any) => state.payment.payment_tax);
    const couponDeliveryFree = useSelector((state: any) => state.menu.couponFreeDelivery);
    const { couponDetails } = useSelector((state: any) => state.menu);
    const hasVoucher = couponDetails && 
      !couponDeliveryFree && 
      (couponDetails.coupon_type.type === COUPON_TYPES.PERCENT || couponDetails.coupon_type.type === COUPON_TYPES.VALUE);
    const calculateTax = (total_price: any) => {
        if (paymentMethod && paymentMethod !== 'Cash' && payment_tax) {
            const delivery_fee_tax_amount = (props.deliveryfee) * parseInt(taxDataCard.tax_percent) / (100 + parseInt(taxDataCard.tax_percent));
            let inclusive_tax: any = (total_price) * parseInt(taxDataCard.tax_percent) / (100 + parseInt(taxDataCard.tax_percent));
            return props.orderType == "Delivery" ? Math.round((inclusive_tax + delivery_fee_tax_amount) * 100) / 100 : Math.round(inclusive_tax * 100) / 100
        } else {
            let inclusive_tax: any = (total_price) * parseInt(taxDataCash.tax_percent) / (100 + parseInt(taxDataCash.tax_percent));
            return Math.round(inclusive_tax * 100) / 100
        }
    }
    const calcTotal = (data: ICartItem[]) => {
        let sum = calculateSubTotal(data, hasVoucher);
        
        if(props?.pos_fee > 0){
            sum += Number(props.pos_fee)
        }
        if(!couponDeliveryFree) {
            if (props.orderType == "Delivery") {
                sum += (props.onlineDeliveryfee > 0 ? props.onlineDeliveryfee : props.deliveryfee);
            }
        } 
        if(donationItems?.length > 0) {
            donationItems.map((item: any) => {
                sum += Number(item.totalItemPrice);
            })
        }
        if(hasVoucher && couponDetails){
            sum -= couponDiscountCal(couponDetails as ICouponDetails, cartData as ICartItem[])
        }

        return Math.round(sum * 100) / 100;
    };
    
    const calcItemTotal = (carts: ICartItem[]) => {
        return calculateSubTotal(carts, hasVoucher);
    };
    
    const itemDiscount = calculateTotalItemDiscount(cartData as ICartItem[]);
    const showQuantity = (donation_id: number, quantity: number) => {
        let showBracketQuantity = true;
        if(donationData?.length > 0) {
            const item: any = donationData.find((item: any) => item.donation_id === donation_id);
            if (item) {
                if(item.amount == 0 || item.quantity_controls == 0 || quantity == 1) {
                    showBracketQuantity = false;
                }
            }
        }
        return showBracketQuantity
    }
    return (
        <div>
            <div className='instructions-box '>
                <div className='bucket-img'>
                    <h5>{t("YOUR_ORDER")}</h5>
                </div>
                <div className='price-info'>
                    <h6>{t("SUB_TOTAL")} :</h6>
                    <h5>{storeSelected ? priceunit + formatPrice(calcItemTotal(cartData)) : priceunit + "0"}</h5>
                </div>
                {props.orderType == "Delivery" &&
                    <div className='price-info'>
                        <h6>{t("DELIVERY_FEE")} :</h6>
                        <h5>{storeSelected ? cartQty > 0 ? priceunit + formatPrice(couponDeliveryFree ? 0 : props.onlineDeliveryfee > 0 ? props.onlineDeliveryfee : props.deliveryfee) : priceunit + "0" : priceunit + "0"}</h5>
                    </div>
                }
                {props.pos_fee > 0 &&
                    <div className='price-info'>
                        <h6>{t("POS_FEE")} :</h6>
                        <h5>{storeSelected ? priceunit + formatPrice(props.pos_fee) : priceunit + "0"}</h5>
                    </div>
                }
                {
                    taxDataCash.tax_percent > 0 || taxDataCard.tax_percent > 0 ?
                    <div className='price-info'>
                        <h6>{t("GST")} {paymentMethod && paymentMethod !== 'Cash' ? `( ${Math.round(taxDataCard.tax_percent)} % )` : `( ${Math.round(taxDataCash.tax_percent)} % )`}:</h6>
                        <h5>{priceunit} {formatPrice(calcTotalGstTax(cartData, paymentMethod, isReverseCard, taxDataCash, taxDataCard, props.orderType, props.deliveryfee, "orderDetail"))}</h5>
                    </div>
                    :
                    null
                }
                {
                    donationItems?.length > 0 ?
                        donationItems.map((item: any) => {
                            return (
                                <div className='price-info' key={item.donation_id}>
                                    <h6>
                                    {t("DONATION")} 
                                        {
                                            showQuantity(item.donation_id, item.quantity) ?
                                                ` (Rs. ${formatPrice(item.price)}${item.quantity > 1 ? " x " + item.quantity + "" : ""})`
                                            :
                                                null
                                        }
                                        {":"}
                                    </h6>
                                    <div className='d-flex align-items-center'>
                                        <i 
                                            className="ri-delete-bin-line donation-bin" 
                                            onClick={() => dispatch(deleteDonationFromCart(item.donation_id))}
                                        >
                                        </i>
                                        <h5 className='w-100'>{priceunit} {formatPrice(item.totalItemPrice)}</h5>
                                    </div>
                                </div>
                            )
                        })
                    :
                    null
                }
                {itemDiscount > 0 && !hasVoucher && (
                    <DiscountDisplay
                        amount={itemDiscount}
                        label="DISCOUNT"
                    />
                )}
                {hasVoucher && couponDetails && (
                    <DiscountDisplay
                        amount={couponDiscountCal(couponDetails as ICouponDetails, cartData as ICartItem[])}
                        label="VOUCHER"
                        couponCode={couponDetails.coupon_code}
                    />
                )}
                <div className='price-info border-top pt-2'>
                    <h6>{t("TOTAL")} :</h6>
                    <h5>{storeSelected ? cartQty > 0 ? priceunit + formatPrice(calcTotal(cartData)) : priceunit + "0" : priceunit + "0"}</h5>
                </div>
            </div>
        </div>
    )
}
